<template>
  <label class="deal-types__tab" :class="{'deal-types__tab--active' : state}">
  <input type="radio"
    :value="value"
    @change="onChange"
    :checked="state"
  >
  {{ label }}
  </label>
</template>

<style lang="scss">

@import './../../../../../_2017/dk/www/html/css/scss/breakpoints';


.deal-types{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  input{
    display: none;
  }

  // width: calc(100% + 30px);
  // margin-left: -15px;

  &__tab{
    flex-basis: 50%;
    flex: 1 0;
    text-align: center;
    letter-spacing: 1px;
    font-size: 12px;
    font-weight: 900;



    cursor: pointer;
    height: 60px;
    line-height: 60px;
    padding-top: 3px;
    text-transform: uppercase;
    color: #585e68;
    background-color: #fff;
    position: relative;
    margin-bottom: 6px;
    @include breakpoint(medium down) {
      font-size: 10px;
      height: 47px;
      line-height: 47px;
    }
    .b-vertical-filter &{
      font-size: 10px;
      height: 47px;
      line-height: 47px;
    }

    &:first-of-type{
      &:after{
        content: "";
        width: 1px;
        height: 80%;
        top: 10%;
        background-color: #e5e4e1;
        position: absolute;
        right: 0;
      }

    }

      &:before{
        height: 6px;
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        content: "";
        background: #f2f4f5;
        transform-origin: 0% 0%;
        animation-name: moove;
        animation-duration: .14s;
      }

    &--active{
        color: #ff3a1e;
      &:before{
        background: #ff6659  !important;
      }
    }
    &:hover{
      color: #ff3a1e;
      background-color: #fafafa;
    }
    input[type=radio]{
      -webkit-appearance: none;
      appearance: none;
      border: 0;
    }
  }
}
@keyframes moove {
  from {
    opacity: 0;
    transform: scaleY(0);
  }

  50% {
    opacity: 1;
    transform: scaleY(.85);
  }

  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

</style>


<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    value: {
      default: '',
    },
    label: {
      default: '',
    },
    modelValue: {
      default: undefined,
    },
    checked: Boolean,
    // model: {}
  },
  computed: {
    state() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      return this.modelValue === this.value;
    }
  },
  methods: {
    onChange() {
      this.toggle();
    },
    toggle() {
      this.$emit('input', this.state ? '' : this.value);
    }
  },
  watch: {
    checked(newValue) {
      if (newValue !== this.state) {
        this.toggle();
      }
    }
  },
  mounted() {
    if (this.checked && !this.state) {
      this.toggle();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/radio.vue